 const tabs = document.querySelectorAll('.product-desc-tab h3');
  const contents = document.querySelectorAll('.product-desc-content');
  tabs.forEach((tab, index) => {
    tab.addEventListener('click', function() {
      tabs.forEach(t => t.classList.remove('active'));
      contents.forEach(c => c.classList.remove('active'));
      tab.classList.add('active');
      contents[index].classList.add('active');
    });
  });


let videos = document.querySelectorAll('[data-youtube]');
for (let video of videos) {
	let id = new URL(video.href).searchParams.get('v');
	video.setAttribute('data-youtube', id);
	video.setAttribute('role', 'button');
	video.innerHTML =
		`<img srcset="https://img.youtube.com/vi/${id}/maxresdefault.jpg" loading="lazy"><img srcset="https://cdn.shopify.com/s/files/1/0612/7124/4978/files/youtub.png?v=1676628090" loading="lazy" class="youtub-ico"><br>
		${video.textContent}`;
}
function clickHandler (event) {
	let link = event.target.closest('[data-youtube]');
	if (!link) return;
	event.preventDefault();
	let id = link.getAttribute('data-youtube');
	let player = document.createElement('div');
	player.innerHTML = `<div class="video-wrapper"><iframe  src="https://www.youtube-nocookie.com/embed/${id}?autoplay=1" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe></div>`;
	link.replaceWith(player);

}
document.addEventListener('click', clickHandler);

const questions = document.querySelectorAll('.product-faq-qus');
  questions.forEach((question) => {
    question.addEventListener('click', function() {
      const answer = this.nextElementSibling;
      if (answer.style.display === "none" || !answer.style.display) {
        document.querySelectorAll('.product-faq-ans').forEach(ans => ans.style.display = "none");
        document.querySelectorAll('.product-faq-qus').forEach(q => q.classList.remove('active'));
        answer.style.display = "block";
        this.classList.add('active');
      } else {
        answer.style.display = "none";
        this.classList.remove('active');
      }
    });
  });

  const titles = document.querySelectorAll('.product_icon-rotate');
  titles.forEach((title) => {
    title.addEventListener('click', function() {
      const content = this.nextElementSibling;
      if (content.classList.contains('active')) {
        content.classList.remove('active');
        this.classList.remove('active');
      } else {
        document.querySelectorAll('.product__description-mobile').forEach(c => c.classList.remove('active'));
        document.querySelectorAll('.product_icon-rotate').forEach(t => t.classList.remove('active'));
        content.classList.add('active');
        this.classList.add('active');
      }
    });
  });